import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { NavController, Platform } from '@ionic/angular';
import { JobService } from 'src/app/services/jobs/job.service';
import { AreaService } from 'src/app/services/Area/area.service';
import { LoaderService } from 'src/app/services/loader/loader.service';
import { PaymentService } from 'src/app/services/payment/payment.service';
import { TransactionService } from 'src/app/services/transaction/transaction.service';
import { UserService } from 'src/app/services/user/user.service';
import { CustomersService } from 'src/app/services/customers/customers.service';
import { CallNumber } from '@ionic-native/call-number/ngx';


@Component({
  selector: 'app-view-job',
  templateUrl: './view-job.page.html',
  styleUrls: ['./view-job.page.scss'],
})
export class ViewJobPage implements OnInit {
jobData:any;
jobId:any;
discount:any;
tax:any;
amount:any;
total :any;
dataFlag:boolean = false;
dueshow=false;
userdata:any;
totalPending:any=0;
showPop:boolean=false;
addOnPending:any;

  constructor(
    private areaService:AreaService,
    private activatedroute:ActivatedRoute,
    private navCtrl:NavController,
    private callNumber:CallNumber,
    private jobService:JobService,
    private platform:Platform,
    private loader:LoaderService,
    private paymentService:PaymentService,
    private transactionService:TransactionService,
    private userService:UserService,
    private customerService:UserService,
  ) { 
   
  }

  ionViewDidEnter(){
    this.areaService.showHome=false  

      this.jobId = this.activatedroute.snapshot.paramMap.get('id'); 
      this.jobService.getJobDetailsForViewService(this.jobId).then((res)=>{
        console.log(res);
        this.jobData = res;
        
      
    this.customerService.getUserDetails(this.jobData.userData.id).then((res)=>{
    this.userdata =res;

    // console.log(this.userdata.addOn.jobId)
    // console.log(this.jobId)

    if(this.jobData.addOn){
    this.dueshow=true;
        }
        this.calculate();


      })
    
        // let dis = (this.jobData.plan.cost * this.jobData.coupon.discount) / 100;
        //   if(dis > this.jobData.coupon.fix_amount){
        //     this.discount = this.jobData.coupon.fix_amount ; 
        //      this.tax = (this.discount * this.jobData.tax.tax_percentage ) / 100;
        //      this.total = this.jobData.plan.cost - this.discount + this.tax;
        //   }else{
        //     this.discount =  dis ; 
        //     this.tax = (this.discount * this.jobData.tax.tax_percentage ) / 100;
        //     this.total = this.jobData.plan.cost - this.discount + this.tax;
        //   }
        this.dataFlag = true;
          
      })
  }

  calculate(){

    if(this.jobData.multiple){
      this.amount = this.jobData.planData.cost * this.jobData.multiple;
    }else{
    this.amount = this.jobData.planData.cost ;
    }
    if(this.jobData.couponId){
      let dis = (this.amount * this.jobData.couponData.discount ) / 100;
      if(dis > this.jobData.couponData.fix_amount){
        if(this.jobData.addOn && this.jobData.addOn.amount && (this.jobData.pendingPayment=='done' ||  this.jobData.pendingPayment == 'completed' ||
        this.jobData.pendingPayment=='pay' || this.jobData.pendingPayment=='cash' || this.jobData.pendingPayment=='online') ) {
          this.discount = this.jobData.couponData.fix_amount ; 
          if(this.jobData.taxData.fixType){
            this.tax = this.jobData.taxData.fixAmount;
          }else{
            this.tax = ((this.amount + this.jobData.addOn.amount- this.discount ) * this.jobData.taxData.tax_percentage ) / 100;
          }
          this.total = this.amount - this.discount + this.tax;
        }else{
          this.discount = this.jobData.couponData.fix_amount ;
          if(this.jobData.taxData.fixType){
            this.tax = this.jobData.taxData.fixAmount;
          }else{
            this.tax = ((this.amount - this.discount ) * this.jobData.taxData.tax_percentage ) / 100;
          } 
           this.total = this.amount - this.discount + this.tax;
        }
      }else{
        if(this.jobData.addOn && this.jobData.addOn.amount && (this.jobData.pendingPayment=='done' || this.jobData.pendingPayment == 'completed' ||
        this.jobData.pendingPayment=='pay' || this.jobData.pendingPayment=='cash' || this.jobData.pendingPayment=='online') ){
          this.discount =  dis ; 
          if(this.jobData.taxData.fixType){
            this.tax = this.jobData.taxData.fixAmount;
          }else{
            this.tax = ((this.amount + this.jobData.addOn.amount- this.discount ) * this.jobData.taxData.tax_percentage ) / 100;
          } 
          this.total = this.amount - this.discount + this.tax;
        }else{
          this.discount =  dis ;
          if(this.jobData.taxData.fixType){
            this.tax = this.jobData.taxData.fixAmount;
          }else{
            this.tax = ((this.amount - this.discount ) * this.jobData.taxData.tax_percentage ) / 100;
          }  
          this.total = this.amount - this.discount + this.tax;
        }
      }
      this.dataFlag = true;
    }else{
      this.dataFlag = true;
      this.discount =  this.amount; 
      if(this.jobData.addOn && this.jobData.addOn.amount && (this.jobData.pendingPayment=='done' || this.jobData.pendingPayment == 'completed' ||
      this.jobData.pendingPayment=='pay' || this.jobData.pendingPayment=='cash' || this.jobData.pendingPayment=='online') ){
        this.discount = this.discount + this.jobData.addOn.amount;
        if(this.jobData.taxData.fixType){
          this.tax = this.jobData.taxData.fixAmount;
        }else{
          this.tax = (this.discount * this.jobData.taxData.tax_percentage ) / 100;
        } 
      }else{
        if(this.jobData.taxData.fixType){
          this.tax = this.jobData.taxData.fixAmount;
        }else{
          this.tax = (this.discount * this.jobData.taxData.tax_percentage ) / 100;
        } 
      }
        this.total = this.amount + this.tax;
    }

    
   if(this.jobData.addOn && this.jobData.addOn.amount && (this.jobData.pendingPayment=='done' || this.jobData.pendingPayment == 'completed' ||
   this.jobData.pendingPayment=='pay' || this.jobData.pendingPayment=='cash' || this.jobData.pendingPayment=='online') ){
     if(this.dueshow){
      this.totalPending=parseFloat(this.jobData.addOn.amount);
      this.addOnPending=parseFloat(this.jobData.addOn.amount).toFixed(2);
      
      this.total=parseFloat(this.total)+parseFloat(this.addOnPending)
     }
   }
   

//    if(this.userdata.pendingService && this.userdata.pendingService.amount ){
//      this.totalPending=parseFloat(this.total)
   
//    }
//    if(this.userdata.pendingService.jobId==this.jobId){
//     this.dueshow=true;
//         }
//    console.log(this.totalPending);
//    this.totalPending=this.totalPending.toFixed(2);
// this.total=this.total.toFixed(2)
  }

  ngOnInit() {
  }

  calNumber(job){
		console.log(job);
		if(this.platform.is("cordova")){
			this.callNumber.callNumber(job.user.mobileObj.number, true)
			.then(res => console.log('Launched dialer!', res))
			.catch(err => console.log('Error launching dialer', err));
		};
	}

  goback(){
    this.navCtrl.navigateBack('/app/contact');
  }
  paypending(){

  }


  payWithRazor() {
    let self=this
    // self.loader.showLoading();
    let amount ;
    if(this.jobData.addOn && this.jobData.addOn.amount){
      amount = (( parseFloat(self.total)  - parseFloat(self.jobData.priceTo) ) *100).toFixed(2)
    }
    // else if(this.userdata.pendingService && this.userdata.pendingService.amount){
    //   amount = (this.totalPending * 100).toFixed() ;
    // }
    console.log(parseFloat(self.total)  - parseFloat(self.jobData.priceTo))
    let userdata = JSON.parse(localStorage.getItem('userProfile'));
    const options: any = {
      key:"rzp_live_a7i7PX5oyV6nnE",
            name:"Fixit Now Service",
            description:this.jobData.addOn.remark,
            amount:parseFloat(this.jobData.priceTo)*100,
            image:  this.jobData.serviceData.serviceBannerImage.url,
            currency:'INR',
            prefill:{
                      name:userdata.fullName,
                      email:userdata.email
                    },
      // order_id: id, // order_id created by you in backend
      modal: {
        // We should prevent closing of the form when esc key is pressed.
        escape: false,
      },
      notes: {
        "UserId":userdata.id
      },
      theme: {
        color:'#f68517'
      }
    };

    options.handler = ((response, error) => {
      options.response = response;
      console.log(response);
      self.addPayment(response)

      console.log(options);
      // call your backend api to verify payment signature & capture transaction
    });
    options.modal.ondismiss = (() => {
    self.loader.hideLoading();

      // handle the case when user closes the form while transaction is in progress
      console.log('Transaction cancelled.');
      // alert('trasaction cancelled')
    });
    const rzp = new this.transactionService.nativeWindow.Razorpay(options);
    setTimeout(() => {
      rzp.open();
    }, 100);


  }

  payOnline(){
    this.payWithRazor()
  }
  payCash(){
    if(this.jobData.serviceStatus == "UserNotPaid"){
      let job = {
        "jobStopTime":new Date(),
        "serviceStatus":"Completed",
        "status":"Completed",
        "pendingPayment":"completed"
      }
      let data ={ 
        "jobId":this.jobId,
        "Amount":this.total.toFixed(2),
        "vendorStatus":true,
        "userStatus":true,
        "vendorType":"cash",
        "userType":"cash",
        "status":true
    }
    this.paymentService.addPayment(data).then((res:any)=>{
      console.log(res);
      let transactionDetails = {
        "paymentId":res.id,
        "usertype":"user",
        "transactionId":"cash",
        "amount":this.total.toFixed(2),
        "transactiontype":"RazorPay",
        "userId":this.jobData.userData.id,
        "status":true,
        "transactionAssets":"cash"
      };
      this.transactionService.addTransaction(transactionDetails).then((ress)=>{
        let transactionDetailsP = {
          "paymentId":res.id,
          "usertype":"vendor",
          "transactionId":"cash",
          "amount":this.total.toFixed(2),
          "transactiontype":"RazorPay",
          "userId":this.jobData.vendorData.id,
          "status":true,
          "transactionAssets":"cash"
        };
        this.transactionService.addTransaction(transactionDetailsP).then((res)=>{
          this.jobService.editJob(job,this.jobData.id).then((resss)=>{
            console.log(resss);
            
            this.navCtrl.pop();
          })
         
        })
       
      })
     
    
    })

    }else{
      let userdata = JSON.parse(localStorage.getItem('userProfile'));

      // this.userService.editUser({"addOn":"","pendingService":""},userdata.id).then((res:any)=>{
        // this.dueshow=false;
        this.jobService.editJob({"pendingPayment":"cash","status":"userPaid"},this.jobId).then((res)=>{
          this.navCtrl.navigateForward(('/View-job/'+this.jobId));
          this.showPop=false;
          this.jobService.getJobDetailsForViewService(this.jobId).then((res)=>{
            console.log(res);
            this.jobData = res;
  
        this.customerService.getUserDetails(this.jobData.userData.id).then((res)=>{
        this.userdata =res;
        if(this.jobData.addOn.jobId==this.jobId){
        this.dueshow=true;
            }
    
          })
            this.calculate();
              
          })
        })
  
    }
   

   

    // })
  }

  addPayment(stripeData){
    let userdata = JSON.parse(localStorage.getItem('userProfile'));
    if(this.jobData.serviceStatus == "UserNotPaid"){
      let filter = {
        "where":{
          "jobId":this.jobData.id
        }
      }
      this.paymentService.getAllPayments(filter).then((res:any)=>{
        this.paymentService.editPayment({"userStatus":true,"userType":"online"},res[0].id).then((ress)=>{
          let transactionDetails = {
          "paymentId":res[0].id,
          "usertype":"user",
          "transactionId":stripeData,
          "amount":this.jobData.priceTo,
          "transactiontype":"RazorPay",
          "userId":userdata.id,
          "status":true,
          "transactionAssets":stripeData
        };
        this.transactionService.addTransaction(transactionDetails).then((res)=>{
          // this.userService.editUser({"addOn":"","pendingService":""},userdata.id).then((res:any)=>{
            // this.dueshow=false;
            let jobdata={
              "jobStopTime":new Date(),
              "serviceStatus":"Completed",
              "status":"Completed",
              "pendingPayment":"completed"
            }
            this.jobService.editJob(jobdata,this.jobId).then((res)=>{
              this.navCtrl.navigateForward(('/View-job/'+this.jobId));
            // this.showPop=false;
    
            })
          // })
         
        })
        })
      })





    }else{
      let data ={ 
        "jobId":this.jobData.id,
        "Amount":this.totalPending,
        "vendorStatus":false,
        "userStatus":true,
        "vendorType":"pending",
        "userType":"RazorPay",
        "status":true
    }
    this.paymentService.addPayment(data).then((res:any)=>{
      console.log(res);
      let transactionDetails = {
        "paymentId":res.id,
        "usertype":"user",
        "transactionId":stripeData,
        "amount":this.jobData.priceTo,
        "transactiontype":"RazorPay",
        "userId":userdata.id,
        "status":true,
        "transactionAssets":stripeData
      };
      this.transactionService.addTransaction(transactionDetails).then((res)=>{
        // this.userService.editUser({"addOn":"","pendingService":""},userdata.id).then((res:any)=>{
          // this.dueshow=false;
          this.jobService.editJob({"pendingPayment":"online","status":"userPaid" , "showAmount":""},this.jobId).then((res)=>{
            this.navCtrl.navigateForward(('/View-job/'+this.jobId));
          // this.showPop=false;
  
          })
        // })
       
      })
    
    })
    }
}

call(){
  this.callNumber.callNumber(this.jobData.vendorData.mobileNo, true)
  .then(res => console.log('Launched dialer!', res))
  .catch(err => console.log('Error launching dialer', err));
}

show(){
  this.showPop=!this.showPop
}
}
